import { fetchApiData, updateApiData } from "../../utils/utils";

export const generateGiftSession = async (appInfo, values) => {
  const api = "giftcard/session/generate";

  const data = {
    period: values.period,
    sub_id: values.sub_id,
  };

  const location = {
    path: "giftPurchase",
    values: data,
  };

  return await updateApiData(appInfo, api, location);
};

export const validateGiftSession = async (appInfo, sessionId) => {
  const api = "giftcard/session/validate";

  const data = {
    session_id: sessionId,
  };

  const location = {
    path: "giftValidation",
    values: data,
  };

  return await updateApiData(appInfo, api, location);
};

export const redeemGiftCard = async (appInfo, giftCode) => {
  const api = "giftcard/redeem";

  const data = {
    giftcode: giftCode,
  };

  const location = {
    path: "giftRedemption",
    values: data,
  };

  return await updateApiData(appInfo, api, location);
};
